
import {
  BuildingIcon,
  CalendarIcon,
  ClipboardListIcon,
  DollarSignIcon,
  FileTextIcon,
  HomeIcon,
  LandmarkIcon,
  ShieldCheckIcon,
  UserRoundIcon,
  UsersIcon,
  type LucideIcon,
} from 'lucide-react';

/** Icons an admin can assign to a section. */
export const SECTION_ICONS: Record<string, LucideIcon> = {
  FileText: FileTextIcon,
  Home: HomeIcon,
  UserRound: UserRoundIcon,
  Users: UsersIcon,
  DollarSign: DollarSignIcon,
  Calendar: CalendarIcon,
  Building: BuildingIcon,
  ShieldCheck: ShieldCheckIcon,
  ClipboardList: ClipboardListIcon,
  Landmark: LandmarkIcon,
};

export const SECTION_ICON_NAMES = Object.keys(SECTION_ICONS);

export function resolveIcon(name: string): LucideIcon {
  return SECTION_ICONS[name] ?? FileTextIcon;
}

